import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { ServiceProvider } from "./context/ServiceProvider";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./config/authConfig";
import "./index.css";
import { ThemeProvider } from "./context/ThemeProvider";

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <ServiceProvider>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </ServiceProvider>
      </BrowserRouter>
    </MsalProvider>
  </React.StrictMode>
);
